
// 之前的代码都是用的 sessionStorage ，目前要改成 localStorage。因为牵涉到多个系统，下面代码做了兼容。

const storageHelper = {
  get: (key: string) => {
    key = 'uaa_' + key
    let str = localStorage.getItem(key) || sessionStorage.getItem(key)
    if (str) {
      try {
        return JSON.parse(str)
      } catch {
        return
      }
    }
    return
  },
  set: (key: string, value: any) => {
    key = 'uaa_' + key
    value = JSON.stringify(value)
    localStorage.setItem(key, value)
  },
  remove: (key: string) => {
    key = 'uaa_' + key
    localStorage.removeItem(key)
  }
}

export { storageHelper }
